import {RcfaStoppageCode as StoppageCode, StoppageCodeType, StoppageCodeTypes} from '@domain/shared'
import {TextField, Autocomplete, MenuItem} from '@mui/material'
import {isString} from 'lodash'
import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {useSearchStoppageCodes} from '../../hooks/useSearchStoppageCodes'
import {FEATURE_NAMESPACE} from '../../localization'

export interface SearchStoppageCodeProperties {
  value: StoppageCode | null
  onChange: (stoppageCode: StoppageCode | null) => void
}

export const SearchStoppageCode: React.FC<SearchStoppageCodeProperties> = ({onChange, value}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const [stoppageType, setStoppageType] = useState<StoppageCodeType>('Kiln')

  const {data: stoppageCodes} = useSearchStoppageCodes(undefined, {
    select: (data) =>
      data.data?.filter(
        (stoppageCode) =>
          stoppageCode.type === stoppageType ||
          (stoppageType === 'Other' && stoppageCode.type === 'Kiln') // we show kiln stoppages even when "Other" is selected
      )
  })

  return (
    <>
      <TextField
        select
        label={t('label.searchStoppageTypeLabel')}
        value={stoppageType}
        onChange={(e) => {
          setStoppageType(e.target.value as StoppageCodeType)
          onChange(null)
        }}
      >
        {StoppageCodeTypes.map((option) => (
          <MenuItem key={option} value={option}>
            {t(`stoppage.types.${option}`)}
          </MenuItem>
        ))}
      </TextField>
      <Autocomplete
        id="search-stoppages"
        options={stoppageCodes || []}
        value={value}
        onChange={(e, stoppage) => onChange(stoppage)}
        sx={{
          maxWidth: 450
        }}
        getOptionLabel={(option) => (isString(option) ? option : `${option.code} - ${option.text}`)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t('label.searchStoppageLabel')}
            placeholder={t('label.searchStoppagePlaceholder')}
          />
        )}
      />
    </>
  )
}
